// extracted by mini-css-extract-plugin
module.exports = {"container":"_1LZCCx","title":"_2NsMog","time-container":"_2wrc85","time-value":"_3H_IlO","time-label":"_2R7r6h","time-second":"_21hnUr"};